import "./HowItWorks.css";

const STEPS = [
	{
		title: "Choose your plan",
		desc: "Start free or pick the membership that fits your practice — upgrade or cancel anytime from your profile.",
		color: "#6B9E8D",
	},
	{
		title: "Discover collections",
		desc: "Browse curated playlists built for meditation, focus, sleep, and devotional listening — or explore the full library.",
		color: "#8B7B9D",
	},
	{
		title: "Press play & breathe",
		desc: "Stream on any device in HD, save tracks offline, and let original 432 Hz compositions guide your moment.",
		color: "#C9A876",
	},
];

const HowItWorks = () => (
	<section className="how-section">
		<p className="how-intro">
			Whether you're starting a meditation, settling into deep work, or winding
			down for the night — getting started with BodhiStreams takes seconds.
		</p>
		<div className="how-steps">
			{STEPS.map((step, index) => (
				<article
					key={step.title}
					className="how-step"
					style={{ "--accent-color": step.color }}
				>
					<div className="how-step-accent" />
					<div className="how-step-number">{index + 1}</div>
					<h3 className="how-step-title">{step.title}</h3>
					<p className="how-step-desc">{step.desc}</p>
				</article>
			))}
		</div>
	</section>
);

export default HowItWorks;
